// src/components/GaleriaAmbiente.tsx
import React from 'react';
import ImageGallery from 'react-image-gallery';
import 'react-image-gallery/styles/css/image-gallery.css';
import '../../styles/galeriaAmbiente.css';
import Recepcao from "../../img/clinica/recepcao.jpg"
import ConsultorioOne from "../../img/clinica/consultorioOne.jpg";
import ConsultorioTwo from "../../img/clinica/consultorioTwo.jpg";
import ConsultorioThree from "../../img/clinica/consultorioThree.jpg";
import Interdisciplinar from "../../img/clinica/interdisciplinar.jpg";
import Recepcionista from "../../img/corpoClinico/sem_foto.jpg"

const images = [
  {
    original: Recepcao,
    thumbnail: Recepcao,
    description: 'Recepção da Clínica Mediação',
  },
  {
    original: ConsultorioOne,
    thumbnail: ConsultorioOne,
    description: 'Consultórios modernos e acolhedores',
  },
  {
    original: ConsultorioTwo,
    thumbnail: ConsultorioTwo,
    description: 'Consultórios modernos e acolhedores',
  },
  {
    original: ConsultorioThree,
    thumbnail: ConsultorioThree,
    description: 'Consultórios modernos e acolhedores',
  },
  {
    original: Interdisciplinar,
    thumbnail: Interdisciplinar,
    description: 'Ambiente interdisciplinar',
  },
];

const GaleriaAmbiente: React.FC = () => {
  return (
    <>
      <div className="galeria-container">
        <h1>Conheça Nossa Clínica</h1>
        <p>
          A Clínica Mediação oferece um ambiente moderno e acolhedor, pensado para o bem-estar de nossos pacientes.
        </p>
        <ImageGallery
          items={images}
          showPlayButton={false}
          showFullscreenButton={true}
          showBullets={true}
          additionalClass="custom-gallery"
        />
      </div>

      {
      /*
      *** ESSA PARTE AQUI FOI MANTIDA PARA A RECEPÇÃO CASO OPTEM POR UTILIZAR NO FUTURO NOVAMENTE
      <div className='title_clinic'>
        <h2 className="titulo" id="Nossa_Equipe">Nossa Equipe</h2>
      </div>
      <div className="space"><br /></div>
      <div className="corpo-clinico">
        <div className="zoom_corpo_clinico">
          <div className="corpo-clinico-container">
            <div className="imagem-container">
              <img src={Recepcionista} alt="Recepcionista Veridiana" />
            </div>
            <div className="space"></div>
            <div className="info-container">
              <h3 className="nome">Veridiana</h3>
              <p className="descricao">
                Nossa recepcionista, Veridiana, é o primeiro sorriso que você encontra ao chegar na Clínica Mediação.
                Com gentileza, empatia e atenção, ela garante que cada paciente se sinta acolhido desde o primeiro contato.
                Seu trabalho é essencial para manter o ambiente da clínica leve, organizado e humano.
              </p>
            </div>
          </div>
        </div>
      </div>*/}

    </>
  );
};

export default GaleriaAmbiente;
